import { get } from '../utils/axios/https';

export const services = {
    getOSContracts: () => get(`api/paciente/contrato/`),
    getOsList: () => get(`api/os/`),
    getVolumeContracts: () => get(`api/volumen/contratoproducto/`),
};
